export default __webpack_public_path__ + "static/media/f22a2b41bbb35dca.cf14fcf7641d855336a548b93ad51c23.svg";